module.exports = __webpack_public_path__ + "static/media/car_keys.18f78914.svg";